import React from 'react';
import { Label } from '../Label';
import Box from '@mui/material/Box';
export const WarrantyLabel = ({ warrantyLength }) => (React.createElement(Label, { icon: "RakutenSymbol", backgroundColor: "green100", textColor: "green500", fontWeight: 400, fontSize: "10px", letterSpacing: "normal", iconSize: "11.6px", padding: "medium", iconStyle: { position: 'relative', top: '1px' } },
    "Garantie\u00A0",
    React.createElement(Box, { component: "span", sx: { fontWeight: 600 } }, `${warrantyLength} an${warrantyLength > 1 && 's'}`)));
